import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { get } from "lodash";
import ServiceProvider from "@client.services/provider";
import { getError } from "@client.utils/errors";

const DEFAULT_DATA = { data: [], load: false };

const initialState = {
  timeMeetingParticipants: DEFAULT_DATA,
  meetings: DEFAULT_DATA,
  error: null,
};

export const getMeetingsAsync = createAsyncThunk(
  "reports/meetings",
  async ({ filter, isCostIndexPresentation, insightId = null }) => {
    return await ServiceProvider.Meetings.getMeetings(
      filter,
      isCostIndexPresentation,
      insightId
    );
  }
);

export const getTimeMeetingParticipantsAsync = createAsyncThunk(
  "reports/timeMeetingParticipants",
  async ({ filter, isCostIndexPresentation }) => {
    return await ServiceProvider.Meetings.getTimeMeetingParticipants(
      filter,
      isCostIndexPresentation
    );
  }
);

export const reportsSlice = createSlice({
  name: "reports",
  initialState,
  reducers: {
    setReportsError: (state, action) => {
      state.error = get(action, "payload", null);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getMeetingsAsync.pending, (state) => {
        state.meetings.load = true;
      })
      .addCase(getMeetingsAsync.fulfilled, (state, action) => {
        state.meetings = {
          data: get(action, "payload", DEFAULT_DATA.data),
          load: false,
        };
      })
      .addCase(getMeetingsAsync.rejected, (state, action) => {
        state.meetings = { ...DEFAULT_DATA };
        state.error = getError(action);
      })
      .addCase(getTimeMeetingParticipantsAsync.pending, (state) => {
        state.timeMeetingParticipants.load = true;
      })
      .addCase(getTimeMeetingParticipantsAsync.fulfilled, (state, action) => {
        state.timeMeetingParticipants = {
          data: get(action, "payload", DEFAULT_DATA.data),
          load: false,
        };
      })
      .addCase(getTimeMeetingParticipantsAsync.rejected, (state, action) => {
        state.timeMeetingParticipants = { ...DEFAULT_DATA };
        state.error = getError(action);
      });
  },
});

export const { setLoadingTimeMeetingParticipants, setReportsError } =
  reportsSlice.actions;

export const makeTimeMeetingParticipants = (state) =>
  state.reports.timeMeetingParticipants;
export const makeMeetings = (state) => state.reports.meetings;
export const makeReportsError = (state) => state.reports.error;

export default reportsSlice.reducer;
